/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Current_VersionInputs */

const en_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Current version: ${i?.version}`)
};

const fr_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Version actuelle : ${i?.version}`)
};

const de_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Aktuelle Version: ${i?.version}`)
};

const it_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versione corrente: ${i?.version}`)
};

const ru_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Текущая версия: ${i?.version}`)
};

const es_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versión actual: ${i?.version}`)
};

const zh_cn2_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`当前版本：${i?.version}`)
};

const ja_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`現在のバージョン: ${i?.version}`)
};

const hi_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वर्तमान संस्करण: ${i?.version}`)
};

const pt_pt2_current_version = /** @type {(inputs: Current_VersionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Versão atual: ${i?.version}`)
};

/**
* | output |
* | --- |
* | "Current version: {version}" |
*
* @param {Current_VersionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const current_version = /** @type {((inputs: Current_VersionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Current_VersionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_current_version(inputs)
	if (locale === "de") return de_current_version(inputs)
	if (locale === "it") return it_current_version(inputs)
	if (locale === "ru") return ru_current_version(inputs)
	if (locale === "es") return es_current_version(inputs)
	if (locale === "zh-CN") return zh_cn2_current_version(inputs)
	if (locale === "ja") return ja_current_version(inputs)
	if (locale === "hi") return hi_current_version(inputs)
	if (locale === "pt-PT") return pt_pt2_current_version(inputs)
	return en_current_version(inputs)
});